import React from 'react';

export default function TableLayout({
  children,
  className = '',
  negativeMargins = false,
  overflowX = true,
  negativeRightMargin = '',
  noOverflow,
}) {
  return (
    <section className={`${className} antialiased mx-[-32px]`}>
      <div className="flex flex-col h-full">
        <div className="w-full mx-auto">
          <div
            className={`px-4 lg:px-0 ${
              noOverflow
                ? ''
                : overflowX
                ? 'overflow-x-auto'
                : 'overflow-x-hidden'
            } ${negativeMargins && `${negativeRightMargin}`}`}
          >
            <table className="w-full table-auto">{children}</table>
          </div>
        </div>
      </div>
    </section>
  );
}
